import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { T } from "../constants/theme";

export default function DonutChart({ data, size = 180, onItemClick }) {
  const total = data.reduce((a, b) => a + b.value, 0);
  const clickable = typeof onItemClick === 'function';

  return (
    <div style={{ display: "flex", gap: 18, alignItems: "center" }}>
      <div style={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              innerRadius={size / 2 - 25}
              outerRadius={size / 2 - 7}
              paddingAngle={2}
              dataKey="value"
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{ borderRadius: 8, border: "none", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)" }}
              itemStyle={{ color: "#2D3748", fontWeight: 600 }}
            />
          </PieChart>
        </ResponsiveContainer>
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", textAlign: "center", pointerEvents: "none" }}>
          <div style={{ fontSize: 20, fontWeight: 700, color: "#1A202C" }}>{total}</div>
          <div style={{ fontSize: 11, color: T?.muted || "#718096" }}>tickets</div>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6, flex: 1 }}>
        {data.map(e => (
          <div
            key={e.name}
            role={clickable && e.value > 0 ? 'button' : undefined}
            tabIndex={clickable && e.value > 0 ? 0 : undefined}
            onClick={clickable && e.value > 0 ? () => onItemClick(e) : undefined}
            onKeyDown={clickable && e.value > 0 ? (ev) => { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); onItemClick(e); } } : undefined}
            style={{
              display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 13,
              color: T?.muted || "#4b5563",
              cursor: clickable && e.value > 0 ? 'pointer' : 'default',
              padding: clickable && e.value > 0 ? '4px 6px' : 0,
              margin: clickable && e.value > 0 ? '-4px -6px' : 0,
              borderRadius: 6,
              transition: 'background 0.15s',
            }}
            onMouseEnter={clickable && e.value > 0 ? (ev) => { ev.currentTarget.style.background = '#F0F4FF'; } : undefined}
            onMouseLeave={clickable && e.value > 0 ? (ev) => { ev.currentTarget.style.background = 'transparent'; } : undefined}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: e.color }} />
              {e.name || e.label}
            </div>
            <span style={{ fontWeight: 700, color: "#1A202C" }}>{e.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
